import React from 'react'
import { MatchResultLayer } from '../components/Match/MatchResultLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const MatchresultPage = () => {
  return (
    <MasterLayout>

        <MatchResultLayer />
    </MasterLayout>
  )
}
